import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { ButtonModule } from 'primeng/button';
import { TableModule , TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { PeopleService } from '../../../shared/services/people.service';
import { Pool, TalentPoolQueryParams, TalentPoolResponse } from '../../../modules/client/dashboard/people/people.interface';
import { HeadingComponent } from "../heading/heading.component";
import { FormsModule } from '@angular/forms';
import { CreateComponent } from "../../../modules/client/dashboard/people/talent-pool/create/create.component";
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ChipModule } from 'primeng/chip';
import { PipesModule } from '../../pipes/pipes.module';
import { HelperService } from '../../services/helper.service';
import { TooltipModule } from 'primeng/tooltip';
@Component({
    selector: 'app-add-to-talent-pool-list',
    standalone: true,
    templateUrl: './add-to-talent-pool-list.component.html',
    styleUrl: './add-to-talent-pool-list.component.scss',
    imports: [TableModule, FormsModule, CommonModule, ButtonModule, HeadingComponent, IconFieldModule, InputTextModule, InputIconModule, CreateComponent, ChipModule, PipesModule, TooltipModule]
})
export class AddToTalentPoolListComponent {
  @Input() firmId!: string;
  @Input() reviewerId!: string;

  @Output() back: EventEmitter<void> = new EventEmitter<void>();
  expandedRows = {};
  viewMyTalentPool: boolean = false;
  totalTalentPoolCount: number = 0;
  talentPoolsData: any[] = [];
  rowExpandedData = [];
  searchText: string = '';
  showSearchChip = false;
  searchTextChip: string = '';
  constructor(
    private toast: ToastService,
    private peopleService: PeopleService,
    private reviewerDetailRef: DynamicDialogRef,
    private dialogService: DialogService,
    public helperService :HelperService
  ) {

  }


  onRowExpand(event: TableRowExpandEvent) {
  }

  onRowCollapse(event: TableRowCollapseEvent) {
    this.rowExpandedData = [];
  }

  onSearchClick(){
    this.getTalentPools({first:0,rows:10});
  }

  onEnter($event:any){
    if($event.keyCode === 13){
      this.getTalentPools({first:0,rows:10});
      if(this.searchText){
        this.showSearchChip = true;
        this.searchTextChip = this.searchText;
      }else{
        this.showSearchChip = false;
      }
    }
  }

  async getTalentPools(event?: any) {
    this.rowExpandedData = [];
    const offset = event.first;
    const limit = event.rows;
    const queryParams: TalentPoolQueryParams = {
      offset: offset,
      limit: limit,
      firmId: this.firmId,
      reviewerId: this.reviewerId
    };
    if(this.searchText){
      queryParams.searchText = this.searchText;
    }
    // Get pools by reviewer ID
    const reviewerPoolsResponse = await this.getPoolsByReviewerId();
    
    // Get unassigned talent pools
    this.peopleService.getAllUnAssignedTalentPoolisting(queryParams).subscribe((unassignedResponse: TalentPoolResponse) => {
      const reviewerPools = reviewerPoolsResponse || [];
      const unassignedPools = unassignedResponse.pools || [];
      const markedReviewerPools = reviewerPools.map((pool: any) => ({
        ...pool,
        isReviewerAssigned: true
      }));
      const markedUnassignedPools = unassignedPools.map((pool: any) => ({
        ...pool,
        isReviewerAssigned: false
      }));
      this.talentPoolsData = [...markedReviewerPools, ...markedUnassignedPools];
      
      this.totalTalentPoolCount = reviewerPools.length + unassignedResponse.totalCount;
    });
  }

  async getPoolsByReviewerId(): Promise<any> {
    const res = await this.peopleService.getPoolsByReviewerId(this.reviewerId);
    return res;
  }

  assignTalentPoolToUser(poolsData: Pool) {
    this.peopleService.assignTalentPoolToUser({ reviewerId: this.reviewerId, talentPoolId: poolsData._id }).subscribe((response: any) => {
      this.toast.showSuccess(`Selected reviewers has been added to ${poolsData.name} `);
      this.getTalentPools({first:0,rows:10});
    })
  }

  backToProfile(){
    this.back.emit();
  }

  goToCreateNewTalentPool() {
    this.reviewerDetailRef = this.dialogService.open(CreateComponent, {
      width: '50vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    });

    this.reviewerDetailRef.onClose.subscribe((data: any) => {
      this.getTalentPools({first:0,rows:10});
    });
  }

  onRemoveChip(){
    this.searchText = '';
    this.searchTextChip = '';
    this.showSearchChip = false;
    this.getTalentPools({first:0,rows:10});
  }
}
